import { styled } from '@mui/material';
import { Box } from '@mui/system';
import FlexBox from 'components/flexbox/FlexBox';
import { H5 } from 'components/Typography';
import { useTranslation } from 'react-i18next'; // styled components

const Wrapper = styled(Box)(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
}));
const HeadingArea = ({}) => {
    const { t } = useTranslation();
    return (
        <Wrapper gap={1}>
            <FlexBox alignItems="center">
                <H5>{t('Abstract Scored')}</H5>
            </FlexBox>
        </Wrapper>
    );
};

export default HeadingArea;
